import {
  Box,
  ButtonBase,
  Divider,
  Paper,
  Stack,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import { useGlobalContext } from "../../stores/Global";
import useBreakpoint from "../../hooks/useBreakpoint";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import Authorized from "../atoms/Authorized";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AvatarWithInitials from "../atoms/AvatarWithInitials";
import { useRef, useState } from "react";
import AccountPopover from "../molecules/AccountPopover";
import Unauthorized from "../atoms/Unauthorized";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import MainSideBarButton from "../molecules/MainSideBarButton";
import HomeIcon from "@mui/icons-material/Home";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useTranslation } from "react-i18next";

export const sideBarWidth = 260;

function MainSideBarContent() {
  const { t } = useTranslation("Navigation");
  const { context, setContext } = useGlobalContext();
  const [open, setOpen] = useState(false);
  const anchorEl = useRef<any>(null);

  const handleClosePopover = () => {
    setOpen(false);
  };

  return (
    <Stack spacing={1} sx={{ p: 2 }}>
      <MainSideBarButton icon={<HomeIcon />} value={t("Home")} path="/home" />
      <Unauthorized>
        <MainSideBarButton
          icon={<PersonIcon />}
          value={t("Login")}
          path="/login"
        />
        <MainSideBarButton
          icon={<PersonAddAlt1Icon />}
          value={t("Register")}
          path="/register"
        />
      </Unauthorized>
      <Authorized role="user">
        <MainSideBarButton
          icon={<ConfirmationNumberIcon />}
          value={t("MyTickets")}
          path="/my-tickets"
        />
      </Authorized>
      <Authorized role="agent">
        <MainSideBarButton
          icon={<SettingsIcon />}
          value={t("Management")}
          path="/m/dashboard"
        />
      </Authorized>
      <Divider />
      <Authorized role="agent">
        <Box ref={anchorEl}>
          <MainSideBarButton
            icon={
              <AvatarWithInitials size={20.56}>
                {context.user?.name || ""}
              </AvatarWithInitials>
            }
            value={context.user?.name || ""}
            onClick={() => setOpen(true)}
          />
        </Box>
      </Authorized>
      <AccountPopover
        open={open}
        anchorEl={anchorEl.current}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
      />
    </Stack>
  );
}

export default function MainSideBar() {
  const { context } = useGlobalContext();

  return (
    <>
      <Box
        height={1}
        width={context.sidebar ? sideBarWidth : undefined}
        display="flex"
        flexDirection="column"
        sx={{ transitionDuration: "200ms" }}
      >
        <Toolbar sx={{ height: 50 + 32 }} />
        <Paper
          sx={{
            position: "relative",
            bgcolor: "background.default",
            flexGrow: 1,
            width: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box flexGrow={1}>
            <MainSideBarContent />
          </Box>
        </Paper>
      </Box>
    </>
  );
}
